
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileSpreadsheet, Sparkle } from "lucide-react";
import type { Client } from "@/types";

interface ClientProgramSectionProps {
  client: Client;
}

export const ClientProgramSection = ({ client }: ClientProgramSectionProps) => {
  const navigate = useNavigate();
  
  // Check if the client has any real programs (not just Basic Training)
  const hasPrograms = client.programs && client.programs.length > 0;
  
  const handleViewProgram = (programId: string) => {
    navigate(`/program-viewer/${programId}`);
  };
  
  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20 h-full">
      <CardHeader>
        <CardTitle className="text-white">Content</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {hasPrograms ? (
          <div className="space-y-6">
            {client.programs.map((program) => (
              <div key={program.id} className="flex items-center justify-between border-b border-white/10 pb-4 last:border-0 last:pb-0">
                <div>
                  <h3 className="text-lg font-medium text-white">{program.name}</h3>
                  {program.duration && (
                    <p className="text-white/70">
                      {program.duration} Week Program
                    </p>
                  )}
                </div>
                <Button 
                  variant="outline"
                  className="gap-2" 
                  onClick={() => handleViewProgram(program.id)}
                >
                  <FileSpreadsheet className="h-4 w-4" />
                  View Program
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-[200px] text-center">
            <Sparkle className="h-8 w-8 text-white/70 mb-2" />
            <p className="text-white/70">No content added just yet, let's change that!</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
